import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Paypal from "../../CourseEnrollment/Payment/CoursePaymentMethod/Assets/paypalPaymentimg.png";
import CreditCard from "../../CourseEnrollment/Payment/CoursePaymentMethod/Assets/CreditCardMethod.svg";
import InteracImage from "../../CourseEnrollment/Payment/CoursePaymentMethod/Assets/Interac.png";
import { BaseUrl } from "../../../Actions/Base";
import { buildPaymentSummaryLines } from "../PaymentSummary/PaymentSummary";
import {
  CompleteSpecialPromotionCheckout,
} from "../../../Actions/SpecialPromotionA";
import axios from "axios";

const ENABLED_METHODS = ["interacETransfer", "paypal", "creditcard"];

const stripeKey =
  window.location.hostname === "vehiclelearning.com"
    ? process.env.REACT_APP_STRIPE_PUBLISHABLE_LIVE_KEY
    : process.env.REACT_APP_STRIPE_PUBLISHABLE_TEST_KEY;

const stripePromise = loadStripe(stripeKey);

/** e-transfer expanded fields (same UI as enrollment Interac form). */
function InteracExpand({ totalPayment, onSubmitDetails, submitting }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    senderEmail: "",
    confirmationId: "",
    paymentDate: "",
    interacscreenshot: null,
    preview: null,
  });
  const [isPaymentConfirmed, setIsPaymentConfirmed] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFormData((prev) => ({
      ...prev,
      interacscreenshot: file,
      preview: URL.createObjectURL(file),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.firstName.trim()) return setError("First name is required.");
    if (!formData.lastName.trim()) return setError("Last name is required.");
    if (!formData.senderEmail.trim()) return setError("Sender email is required.");
    if (!formData.confirmationId.trim())
      return setError("Confirmation ID is required.");
    if (!formData.paymentDate.trim()) return setError("Payment date is required.");
    if (!formData.interacscreenshot) return setError("Screenshot is required.");

    setError("");
    onSubmitDetails?.({
      firstName: formData.firstName,
      lastName: formData.lastName,
      senderEmail: formData.senderEmail,
      confirmationId: formData.confirmationId,
      paymentDate: formData.paymentDate,
      interacscreenshot: formData.interacscreenshot,
      amount: totalPayment,
    });
  };

  return (
    <div className="w-full flex flex-col gap-[10px] mt-[20px] p-[5px] lg:p-[20px] bg-[#F8FAFA] rounded-[21px] shadow">
      <div className="text-[22px] font-bold text-[#404040]">
        Send Your E-Transfer
      </div>
      <p className="text-[#6B6B6B] text-[20px]">
        To send the Interac e-Transfer, use the following details:
      </p>

      <div
        className="mt-[15px] lg:h-[50px] p-[10px] lg:p-[20px] w-full bg-[#FFFFFF] rounded-[4px] flex flex-col lg:flex-row lg:items-center lg:gap-[50px]"
        style={{ border: "1px solid #EFEFEF" }}
      >
        <p className="text-[18px] font-bold text-[#6B6B6B]">Company Name:</p>
        <p className="text-[18px] text-[#6B6B6B]">
          Meliorist Information Technology Inc.
        </p>
      </div>

      <div className="w-full flex flex-col lg:flex-row lg:items-end gap-[20px]">
        <div
          className="mt-[15px] lg:h-[50px] p-[10px] lg:p-[20px] w-full lg:w-[70%] bg-[#FFFFFF] rounded-[4px] flex flex-col lg:flex-row lg:items-center lg:gap-[50px]"
          style={{ border: "1px solid #EFEFEF" }}
        >
          <p className="text-[18px] font-bold text-[#6B6B6B]">Email:</p>
          <p className="text-[18px] text-[#6B6B6B]">
            vlipayment@vehiclelearning.com
          </p>
        </div>
      </div>

      <div className="mt-[20px] flex items-start gap-3">
        <input
          type="checkbox"
          id="registerInteracConfirm"
          checked={isPaymentConfirmed}
          onChange={(e) => setIsPaymentConfirmed(e.target.checked)}
          className="mt-1"
        />
        <label htmlFor="registerInteracConfirm" className="text-[16px] text-[#404040]">
          I confirm that I have sent / will send the Interac e-Transfer for $
          {Number(totalPayment).toFixed(2)}.
        </label>
      </div>

      {isPaymentConfirmed && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <div>
              <label className="text-[18px] text-[#5A7184] font-semibold">
                First Name
              </label>
              <input
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                type="text"
                className="p-2 rounded-[4px] w-full"
                style={{ border: "1px solid #EFEFEF", outline: "none" }}
                placeholder="First name"
              />
            </div>
            <div>
              <label className="text-[18px] text-[#5A7184] font-semibold">
                Last Name
              </label>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                type="text"
                className="p-2 rounded-[4px] w-full"
                style={{ border: "1px solid #EFEFEF", outline: "none" }}
                placeholder="Last name"
              />
            </div>
            <div>
              <label className="text-[18px] text-[#5A7184] font-semibold">
                Sender Email
              </label>
              <input
                name="senderEmail"
                value={formData.senderEmail}
                onChange={handleChange}
                type="email"
                className="p-2 rounded-[4px] w-full"
                style={{ border: "1px solid #EFEFEF", outline: "none" }}
                placeholder="email@example.com"
              />
            </div>
            <div>
              <label className="text-[18px] text-[#5A7184] font-semibold">
                Confirmation ID
              </label>
              <input
                name="confirmationId"
                value={formData.confirmationId}
                onChange={handleChange}
                type="text"
                className="p-2 rounded-[4px] w-full"
                style={{ border: "1px solid #EFEFEF", outline: "none" }}
                placeholder="01234"
              />
            </div>
            <div>
              <label className="text-[18px] text-[#5A7184] font-semibold">
                Date of Payment Sent
              </label>
              <input
                name="paymentDate"
                value={formData.paymentDate}
                onChange={handleChange}
                type="date"
                className="p-2 rounded-[4px] w-full"
                style={{ border: "1px solid #EFEFEF", outline: "none" }}
              />
            </div>
          </div>

          <div className="mt-5">
            <label className="text-[18px] text-[#5A7184] font-semibold">
              Screenshot
            </label>
            <div className="mt-2 w-full">
              <input
                type="file"
                id="registerScreenshotUpload"
                accept="image/*"
                onChange={handleFileChange}
                className="hidden"
              />
              <label
                htmlFor="registerScreenshotUpload"
                className="w-[270px] lg:w-[350px] flex items-center gap-3 bg-[#FFFFFF] px-4 py-3 rounded-[4px]"
                style={{ border: "1px solid #EFEFEF" }}
              >
                {formData.preview ? (
                  <img
                    src={formData.preview}
                    alt="Uploaded Interac e-Transfer payment screenshot"
                    className="w-[100px] h-[100px] border rounded"
                  />
                ) : (
                  <div className="w-[150px] h-[37px] bg-[#C5C7F3] rounded-[6px] flex items-center justify-center gap-[10px]">
                    <CloudUploadIcon style={{ color: "#FFFFFF", fontSize: "22px" }} />
                    <span className="text-[16px] text-[#FFFFFF]">upload</span>
                  </div>
                )}
                <span className="text-[#B0B0B0] text-[18px]">
                  Upload Screenshot
                </span>
              </label>
            </div>
          </div>

          {error && <p className="text-[#ff0000] text-[14px]">{error}</p>}

          <div className="w-full flex justify-end mt-8">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={submitting}
              className="w-[170px] h-[50px] bg-[#A1A3EF] cursor-pointer rounded-[8px] text-[#FFF] text-[26px] border-none disabled:opacity-60"
            >
              {submitting ? "Saving..." : "Submit"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

/** Credit card expand — charge then persist via special-promotion-checkout. */
function CreditCardExpand({
  totalPayment,
  clientSecret,
  onCheckout,
  submitting,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const handleCardPaymentSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!stripe || !elements) {
      setError("Stripe is not properly initialized.");
      setLoading(false);
      return;
    }

    const { error: pmError, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

    if (pmError) {
      setError(pmError.message);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BaseUrl}/api/stripecardpayment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentMethodId: paymentMethod.id,
          TotalFee: totalPayment,
        }),
      });
      const data = await response.json();

      if (data.error) {
        setError(data.error);
        setLoading(false);
        return;
      }

      const { paymentIntent, error: confirmError } =
        await stripe.confirmCardPayment(data.clientSecret);

      if (confirmError) {
        setError(confirmError.message);
        setLoading(false);
        return;
      }

      if (paymentIntent.status === "succeeded") {
        const card = data.card || {};
        await onCheckout?.({
          paymentMethod: "creditcard",
          cardDetails: {
            brand: card.brand,
            exp_month: card.exp_month,
            exp_year: card.exp_year,
            last4: card.last4,
            postal_code: card.postal_code,
          },
        });
        setPaymentSuccess(true);
      }
    } catch (err) {
      setError(err?.message || "Payment failed.");
    }

    setLoading(false);
  };

  return (
    <div className="w-full md:w-[70%] mx-auto mt-[15px]">
      <CardElement
        options={{
          style: {
            base: {
              fontSize: "18px",
              padding: "10px",
              color: "#424770",
              backgroundColor: "white",
              "::placeholder": { color: "#aab7c4" },
            },
            invalid: { color: "#9e2146" },
          },
        }}
      />
      <div className="w-full flex justify-end">
        <button
          type="button"
          disabled={!stripe || loading || submitting || !totalPayment}
          className="bg-[#A1A3EF] text-white p-3 border-none rounded-[8px] cursor-pointer disabled:opacity-60"
          style={{ marginTop: "10px" }}
          onClick={handleCardPaymentSubmit}
        >
          {loading || submitting
            ? "Processing..."
            : `Pay $${Number(totalPayment).toFixed(2)}`}
        </button>
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {paymentSuccess && (
        <p style={{ color: "green" }}>Payment successful!</p>
      )}
      {!clientSecret && (
        <p className="text-[14px] text-[#707070] mt-2">Loading card form...</p>
      )}
    </div>
  );
}

const PaymentMethods = ({
  selectionState,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  onBeforeSelectPaymentMethod,
  checkoutBase,
  onCheckoutSuccess,
}) => {
  const dispatch = useDispatch();
  const { checkoutLoading, checkoutResult, error: checkoutError } = useSelector(
    (store) => store.SpecialPromotionReducer || {}
  );

  const { total } = useMemo(
    () => buildPaymentSummaryLines(selectionState),
    [selectionState]
  );
  const totalPayment = Number(total.toFixed(2));
  const PaypalBtnRef = useRef();
  const [clientSecret, setClientSecret] = useState("");
  const [localError, setLocalError] = useState("");
  const [localSuccess, setLocalSuccess] = useState("");

  const PayPalButton = window.paypal?.Buttons?.driver("react", {
    React,
    ReactDOM,
  });

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/banksetup-intent`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.clientSecret) setClientSecret(data.clientSecret);
      } catch (error) {
        console.error("Error fetching clientSecret:", error.message);
      }
    };
    fetchClientSecret();
  }, []);

  const runCheckout = async (extra) => {
    setLocalError("");
    setLocalSuccess("");
    if (!checkoutBase?.email) {
      setLocalError("Email is required to complete payment.");
      return null;
    }
    try {
      const data = await dispatch(
        CompleteSpecialPromotionCheckout({
          ...checkoutBase,
          totalAmount: totalPayment,
          ...extra,
        })
      );
      setLocalSuccess(
        extra.paymentMethod === "interacETransfer"
          ? "Interac details submitted. We will confirm your payment shortly."
          : "Payment completed successfully!"
      );
      onCheckoutSuccess?.(extra.paymentMethod);
      return data;
    } catch (err) {
      setLocalError(
        err?.response?.data?.error ||
          err?.message ||
          "Failed to save payment. Please try again."
      );
      return null;
    }
  };

  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    if (!ENABLED_METHODS.includes(value)) return;

    if (typeof onBeforeSelectPaymentMethod === "function") {
      const isValid = onBeforeSelectPaymentMethod();
      if (!isValid) {
        setSelectedPaymentMethod("");
        return;
      }
    }

    setLocalError("");
    setLocalSuccess("");
    setSelectedPaymentMethod(value);
  };

  if (selectionState?.licenseType === "G1") {
    return null;
  }

  return (
    <div className="w-full flex flex-col justify-center items-center gap-[10px] px-4 py-10">
      <div className="w-[100%] lg:w-[80%] flex flex-col gap-[10px]">
        <p className="text-[#404040] text-[20px] font-bold">
          Add Payment Method
        </p>

        <div className="w-full flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[15px]">
          <p className="text-[#000000] text-[18px] font-bold">Payment Method</p>

          {totalPayment > 0 && (
            <p className="text-[16px] text-[#404040]">
              Total Payable:{" "}
              <span className="font-semibold text-[#000000]">
                ${totalPayment.toFixed(2)}
              </span>
            </p>
          )}

          {(localError || checkoutError?.error) && (
            <p className="text-[#ff0000] text-[14px]">
              {localError || checkoutError?.error}
            </p>
          )}
          {(localSuccess || checkoutResult?.success) && (
            <p className="text-[#2E7D32] text-[14px]">
              {localSuccess || checkoutResult?.message}
            </p>
          )}

          <div className="mt-[10px] flex flex-col gap-[10px]">
            {/* e-transfer */}
            <div
              className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
              style={{ border: "1px solid #E8E8E8" }}
            >
              <div className="w-full flex items-center justify-between">
                <div>
                  <input
                    type="radio"
                    id="interacETransfer"
                    name="registerPaymentMethod"
                    value="interacETransfer"
                    checked={selectedPaymentMethod === "interacETransfer"}
                    onChange={handlePaymentMethodChange}
                    className="mr-2"
                  />
                  <label
                    htmlFor="interacETransfer"
                    className="text-[18px] text-[#707070]"
                  >
                    e-transfer
                  </label>
                </div>
                <img
                  src={InteracImage}
                  alt="Interac e-Transfer payment option"
                  className="w-[30px] h-[30px]"
                />
              </div>

              {selectedPaymentMethod === "interacETransfer" && (
                <div className="w-full md:w-[95%] mx-auto">
                  <InteracExpand
                    totalPayment={totalPayment}
                    submitting={checkoutLoading}
                    onSubmitDetails={(details) =>
                      runCheckout({
                        paymentMethod: "interacETransfer",
                        interacDetails: details,
                      })
                    }
                  />
                </div>
              )}
            </div>

            {/* PayPal */}
            <div
              className="w-full flex flex-col gap-[15px] px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden"
              style={{ border: "1px solid #E8E8E8" }}
            >
              <div className="w-full flex items-center justify-between">
                <div>
                  <input
                    type="radio"
                    id="paypal"
                    name="registerPaymentMethod"
                    value="paypal"
                    checked={selectedPaymentMethod === "paypal"}
                    onChange={handlePaymentMethodChange}
                    className="mr-2"
                  />
                  <label htmlFor="paypal" className="text-[18px] text-[#707070]">
                    Paypal
                  </label>
                </div>
                <img
                  src={Paypal}
                  alt="PayPal payment option"
                  className="h-[30px] w-[100px] object-contain"
                />
              </div>

              {selectedPaymentMethod === "paypal" && (
                <div className="w-full flex justify-center items-center">
                  <div className="w-[50%] min-h-[50px]" ref={PaypalBtnRef}>
                    {PayPalButton ? (
                      <PayPalButton
                        style={{ layout: "vertical" }}
                        createOrder={async () => {
                          // Same pattern as enrollment CreateOrder: axios → return id string
                          try {
                            const { data } = await axios.post(
                              `${BaseUrl || ""}/api/special-promotion-paypal-order`,
                              {
                                TotalPrice: totalPayment,
                                Currency: "USD",
                              },
                              { withCredentials: true }
                            );

                            if (!data?.id) {
                              console.error(
                                "PayPal createOrder: missing order id",
                                data
                              );
                              throw new Error("PayPal order id missing");
                            }

                            console.log("PayPal createOrder id:", data.id);
                            return String(data.id);
                          } catch (err) {
                            console.error("PayPal createOrder failed:", err);
                            setLocalError(
                              err?.response?.data?.error ||
                                err?.message ||
                                "Could not start PayPal checkout."
                            );
                            throw err;
                          }
                        }}
                        onApprove={async (data) => {
                          try {
                            await runCheckout({
                              paymentMethod: "paypal",
                              paypalOrderId: data.orderID,
                            });
                          } catch (err) {
                            console.error("PayPal onApprove failed:", err);
                            setLocalError(
                              "PayPal payment could not be completed. Please try again."
                            );
                          }
                        }}
                        onCancel={() => {
                          setLocalError("");
                          console.log("PayPal checkout cancelled by user");
                        }}
                        onError={(err) => {
                          console.error("PayPal button onError:", err);
                          setLocalError(
                            "PayPal payment failed. Please try again."
                          );
                        }}
                      />
                    ) : (
                      <p className="text-[14px] text-[#707070] text-center">
                        PayPal is loading... Refresh if it does not appear.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Credit Card */}
            <div
              className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
              style={{ border: "1px solid #E8E8E8" }}
            >
              <div className="w-full flex items-center justify-between">
                <div>
                  <input
                    type="radio"
                    id="creditcard"
                    name="registerPaymentMethod"
                    value="creditcard"
                    checked={selectedPaymentMethod === "creditcard"}
                    onChange={handlePaymentMethodChange}
                    className="mr-2"
                  />
                  <label
                    htmlFor="creditcard"
                    className="text-[18px] text-[#707070]"
                  >
                    Credit Card
                  </label>
                </div>
                <img src={CreditCard} alt="Credit card payment option" />
              </div>

              {selectedPaymentMethod === "creditcard" &&
                (clientSecret ? (
                  <Elements
                    stripe={stripePromise}
                    options={{
                      clientSecret,
                      appearance: { theme: "stripe" },
                      paymentMethodCreation: "manual",
                    }}
                  >
                    <CreditCardExpand
                      totalPayment={totalPayment}
                      clientSecret={clientSecret}
                      submitting={checkoutLoading}
                      onCheckout={runCheckout}
                    />
                  </Elements>
                ) : (
                  <p className="text-[14px] text-[#707070] mt-[15px]">
                    Loading card form...
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
